import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";
import { uploadSingleImage } from "../../utils/uploadFiles";

const addStyleGuide = (data, history) => async (dispatch) => {
    dispatch(showLoaderAction());
    const styleGuideData = { ...data };
    const image = await uploadSingleImage(styleGuideData?.singleImage);
    styleGuideData.singleImage = image[0] ?? "";

    const res = await api("post", Constants.END_POINT.ADD_STYLE_GUIDE, styleGuideData);
    if (res.success) {
        history.go(-1);
        dispatch(showToast({ severity: "success", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const fetchStyleGuides = () => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.STYLE_GUIDES);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.STYLE_GUIDES,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const fetchStyleGuideDetails = (id) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.STYLE_GUIDES + id);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            dispatch({
                type: types.STYLE_GUIDES_DETAILS,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const updateStyleGuide = (id, data, history) => async (dispatch) => {
    dispatch(showLoaderAction());

    const styleGuideData = { ...data };
    if (styleGuideData.singleImage instanceof File) {
        const image = await uploadSingleImage(styleGuideData.singleImage);
        styleGuideData.singleImage = image[0] ?? "";
    }

    const res = await api("put", Constants.END_POINT.STYLE_GUIDES + id, styleGuideData);
    if (res.success) {
        history.go(-1);
        dispatch(showToast({ severity: "success", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

const deleteStyleGuide = (id) => async (dispatch) => {
    dispatch(showLoaderAction());

    const res = await api("delete", Constants.END_POINT.STYLE_GUIDES + id);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(fetchStyleGuides());
    }
    dispatch(hideLoaderAction());
};

export { addStyleGuide, fetchStyleGuides, fetchStyleGuideDetails, updateStyleGuide, deleteStyleGuide };
